"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _Button = _interopRequireDefault(require("../../Button")); // Copyright © VNG Realisatie 2020
// Licensed under the EUPL
//


var ActionButton = function ActionButton(props) {
  var type = props.onClick ? {
    type: 'button'
  } : {};
  return /*#__PURE__*/_react["default"].createElement(_Button["default"], (0, _extends2["default"])({
    size: "small",
    variant: "link"
  }, type, props));
};

ActionButton.propTypes = {
  onClick: _propTypes.func
};
var _default = ActionButton;
exports["default"] = _default;